import { OrderStatus } from "../../data/BaseEntity";
import type { SavedOrder } from "../orderTypes";

export function shouldShowTodos({ status }: Pick<SavedOrder, "status">) {
  return ![
    OrderStatus.TO_ORDER,
    OrderStatus.INITIAL,
    OrderStatus.CONFIRMED,
    OrderStatus.CANCELLATION_SENT,
    OrderStatus.CANCELLED,
  ].includes(status);
}
